import { Grid, makeStyles, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import { VictoryPie, VictoryAnimation, VictoryLabel } from "victory";
import { amber, deepOrange, green, lightGreen, lime, orange, red, yellow } from "@material-ui/core/colors";
import { useTranslation } from "react-i18next";

const ProgressChart = ({ showSuccess, percent, data, isCompleted, isModule }) => {
  const styles = useStyles();
  const { t } = useTranslation();

  const [comlpeted, setComlpeted] = useState(false);

  useEffect(() => {
    isCompleted && setComlpeted(true);
  }, [isCompleted]);

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" className={styles.progressTitle}>
          {!isModule ? t("formationProgress") : t("progreso_del_modulo")}
        </Typography>
      </Grid>
      {!showSuccess && (
        <Grid item xs={7} md={12} style={{ marginBottom: -42 }}>
          <svg viewBox="0 0 200 200" width="90%" height="100%" style={{ marginTop: -28 }}>
            <circle cx={100} cy={100} r={76} fill="#e0e0e0" />
            <circle cx={100} cy={100} r={69} fill={comlpeted ? green[500] : "#f5f5f5"} />
            <VictoryPie
              standalone={false}
              animate={{ duration: 1000 }}
              width={200}
              height={200}
              data={data}
              innerRadius={76}
              radius={68}
              cornerRadius={16}
              labels={() => null}
              style={{
                data: {
                  fill: ({ datum }) => {
                    const color = colorRange[parseInt(datum.y / 10) * 10];
                    return datum.x === 1 ? color : "transparent";
                  },
                },
              }}
            />
            <VictoryAnimation duration={1000} data={{ percent: percent, data: data }}>
              {(newProps) => {
                return (
                  <VictoryLabel
                    textAnchor="middle"
                    verticalAnchor="middle"
                    x={100}
                    y={100}
                    text={`${Math.round(newProps.percent)}%`}
                    style={{
                      fill: newProps.percent === 100 ? "white" : colorRange[parseInt(newProps.percent / 10) * 10],
                      fontFamily: "1.6rem Google Sans,Arial,sans-serif",
                      fontWeight: 500,
                      fontSize: 36,
                    }}
                  />
                );
              }}
            </VictoryAnimation>
          </svg>
        </Grid>
      )}
      {showSuccess && <Lottie animationData={require("../../assets/success.json")} style={{ height: "80%", width: "80%", paddingLeft: 9 }} loop={false} />}
    </>
  );
};

export default ProgressChart;

const useStyles = makeStyles((theme) => ({
  progressTitle: {
    color: "#80868b",
    font: "500 12px/15.6px Google Sans,Arial,sans-serif",
    letterSpacing: "1.3px",
    textTransform: "uppercase",
    paddingBottom: theme.spacing(3.5),
  },
}));

const colorRange = {
  0: red[900],
  10: red[800],
  20: deepOrange[900],
  30: orange[900],
  40: amber[900],
  50: yellow[900],
  60: yellow[800],
  70: yellow[700],
  80: lime[500],
  90: lightGreen[500],
  100: green[500],
};
